module.exports = __webpack_public_path__ + "static/media/icon-win-b.f20cf6ae.svg";